// extracted by mini-css-extract-plugin
export var notificationHost = "_co-0";